export default __webpack_public_path__ + "static/media/1_active.62d1fcb9.png";